import React from 'react';
import { boutiqueData } from '../data/mock';
import { Sparkles, Heart, Award } from 'lucide-react';

const BoutiqueSection = () => {
  const icons = [Sparkles, Heart, Award];

  return (
    <section id="boutique" className="py-20 lg:py-32 bg-gradient-to-b from-white to-rose-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-light text-gray-800 mb-4 tracking-tight">
            {boutiqueData.title}
          </h2>
          <p className="text-lg text-rose-400 uppercase tracking-widest font-medium">
            {boutiqueData.subtitle}
          </p>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16">
          {/* Images */}
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2">
              <img
                src={boutiqueData.images[0]}
                alt="Intérieur boutique Motherstore"
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="col-span-2">
              <img
                src={boutiqueData.images[1]}
                alt="Ambiance boutique"
                className="w-full h-64 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="space-y-8">
            <p className="text-lg text-gray-700 leading-relaxed">
              {boutiqueData.description}
            </p>

            {/* Features */}
            <div className="space-y-6 pt-6">
              {boutiqueData.features.map((feature, index) => {
                const Icon = icons[index];
                return (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center">
                      <Icon className="text-rose-400" size={24} />
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-gray-800 mb-1">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Location Info */}
        <div className="bg-white rounded-lg shadow-sm p-8 text-center max-w-2xl mx-auto border border-gray-100">
          <p className="text-gray-700 text-lg">
            Venez nous rendre visite près de la{' '}
            <span className="font-medium text-rose-400">Place de la Concorde</span>
            {' '}et découvrez l'univers Motherstore dans notre boutique parisienne.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BoutiqueSection;
